import { z } from "zod";
import { addressSchema, auditInfoSchema } from "../common/schemas";

export const sageOfficeViewSchema = z.object({
    id: z.string(),
    name: z.string(),
    address: addressSchema,
    created: auditInfoSchema.nullable().optional(),
    modified: auditInfoSchema.nullable().optional(),
    deleted: auditInfoSchema.nullable().optional(),
    isDeleted: z.boolean(),
});

export type SageOfficeView = z.infer<typeof sageOfficeViewSchema>;

export const sageOfficeListResponseSchema = z.object({
    results: z.array(sageOfficeViewSchema),
});

export const sageOfficeMutationResponseSchema = z.object({
    sageOffice: sageOfficeViewSchema,
});

export interface SageOfficeUpsertPayload {
    readonly id: string;
    readonly name: string;
    readonly address: {
        readonly street1: string;
        readonly street2?: string | null;
        readonly city: string;
        readonly region: string;
        readonly postalCode: string;
        readonly country: string;
    };
}
